import { useState } from "react";
import { X, Sparkles } from "lucide-react";

const KEY = "wwr_open_banner_dismissed";

export const LaunchBanner = () => {
  const [show, setShow] = useState(() => localStorage.getItem(KEY) !== "1");
  if (!show) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  return (
    <div className="relative bg-gradient-to-r from-teal-500/20 via-amber-400/15 to-teal-500/20 border-b border-teal-400/20 backdrop-blur-md" data-testid="launch-banner">
      <div className="max-w-6xl mx-auto px-10 py-2.5 text-center text-xs sm:text-sm text-neutral-100">
        <Sparkles size={13} className="inline -mt-0.5 mr-2 text-amber-300" />
        <strong className="font-semibold">We're open.</strong> Thank you to everyone who waited with us. This is for you.
      </div>
      <button type="button" onClick={close} aria-label="Dismiss announcement" data-testid="launch-banner-dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full text-neutral-300 hover:text-white hover:bg-white/10">
        <X size={14} />
      </button>
    </div>
  );
};
